import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';

export default function SeasonSelector({ value, onChange }) {
  const { t } = useTranslation();
  const [seasons, setSeasons] = useState([]);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    api.get('/seasons').then(r => {
      const data = r.data.data || [];
      setSeasons(data);
      if (data.length > 0) {
        const active = data.find(s => s.is_active);
        if (active) onChangeRef.current(active.id);
      }
    }).catch(() => {});
  }, []);

  return (
    <div className="form-group" style={{ marginBottom: 8 }}>
      <select
        value={value || ''}
        onChange={e => onChange(e.target.value || null)}
        style={{ fontSize: '0.85rem', fontWeight: 700 }}
      >
        <option value="">{t('seasons.all')}</option>
        {seasons.map(s => (
          <option key={s.id} value={s.id}>
            {s.name} {s.is_active ? '●' : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
